import styled from '@emotion/styled';
import { Breadcrumbs, Link, Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';

import { InsightCategory } from '../../../../entity/InsightCategory';
import theme from '../../../../theme';
import { SPACING_UNIT } from '../../../constant/spacing';
import mq from '../../../styleUtility/mediaquery';

interface Props {
  insightCategory: InsightCategory;
  isSingleCategoryPage?: boolean;
  orgId?: string | null;
}

export const InsightCategoryTitle: FC<Props> = ({ orgId = '', insightCategory, isSingleCategoryPage = false }) => {
  return (
    <Heading>
      <Title>{insightCategory.name}</Title>
      <Description>{insightCategory.description}</Description>

      {isSingleCategoryPage && (
        <BreadcrumbsContainer aria-label="breadcrumb">
          <Link
            color="inherit"
            component={RouterLink}
            underline={'none'}
            to={`/latest-insights${orgId != null && `?org=${orgId}`}`}
          >
            <FormattedMessage id="insight_category_page.title.breadcrumbs.home" />
          </Link>
          <Typography color={'textPrimary'}>{insightCategory.name}</Typography>
        </BreadcrumbsContainer>
      )}
    </Heading>
  );
};

const Heading = styled('div')`
  margin-bottom: ${SPACING_UNIT * 3}px;
  ${mq('sp')}: {
    margin-bottom: ${SPACING_UNIT}px;
  } ;
`;

const Title = styled(Typography)`
  font-size: ${theme.typography.h5.fontSize};
`;

const Description = styled(Typography)`
  font-size: ${theme.typography.subtitle2.fontSize};
`;

const BreadcrumbsContainer = styled(Breadcrumbs)`
  margin-top: ${SPACING_UNIT * 2}px;
  margin-bottom: ${SPACING_UNIT}px;
`;
